import { notification } from 'antd';
import { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../../App.context';
import { ApiContext } from '../../../utils/networking/Api.context';

export default function useAppearenceHook() {
  const { API } = useContext(ApiContext);
  const { appState, appActions } = useContext(AppContext);
  const { translate, getSelectedHotel } = appActions;
  const [state, setState] = useState({
    userCanEdit: appState.role !== 'guest',
    hotel: null,
    isLoading: false,
    logo: null,
    bgColor: null,
    color1: null,
    color2: null,
    font: null,
    kioskBgColor: null,
    kioskTitleColor: null,
    kioskLogo: null,
    chainLogo: null,
    chainKioskLogo: null,
    chainId: null,
    sliderImages: [],
    paperlessVersion: 'v1',
    chainColor1: null,
    chainColor2: null,
    chainBgColor: null,
    hotelActivePreview: false,
    chainActivePreview: false,
    paperlessActivePreview: false,
  });

  useEffect(() => {
    actions.onHotelSelected(getSelectedHotel());
  }, [appState.selectedHotel]);

  const actions = {
    copyToHotels: params => {
      const { hotels, appearanceData } = params;
      if (!hotels || hotels.length === 0) return;
      updateState({ isLoading: true });
      Promise.all(
        hotels.map(hotel => {
          // Check if is kiosk or checkin online
          if (appearanceData === 'kiosk') {
            actions.updateKiosk(false, hotel.hotelId);
          } else {
            actions.updateApearence(false, hotel.hotelId);
          }
        })
      ).catch(error => {
        notification.error({
          message: error?.response?.data?.message || 'Error al copiar apariencia',
        });
        updateState({ isLoading: false });
      });
    },

    loadAppearence: hotelId => {
      updateState({ isLoading: true });
      API.appearenceRequest(hotelId)
        .then(res => {
          updateState({
            isLoading: false,
            color1: res?.color1 || 'fff',
            color2: res?.color2 || 'fff',
            bgColor: res['bg_color'] || 'fff',
            logo: res?.logo,
            kioskBgColor: res['kiosk_bg_color'] || 'fff',
            kioskTitleColor: res['kiosk_title_color'] || 'fff',
            kioskLogo: res['kiosk_logo'],
            chainLogo: res['chain_logo'],
            chainKioskLogo: res['chain_kiosk_log'],
            chainId: res['chain_id'],
            sliderImages: res.sliderImages,
            paperlessVersion: res.paperlessVersion,
            chainColor1: res?.chainColor1 || 'fff',
            chainColor2: res?.chainColor2 || 'fff',
            chainBgColor: res?.chainBgColor || 'fff',
          });
        })
        .catch(err => {
          console.warn(err);
          updateState({ isLoading: false });
          notification.error({
            message: err?.response?.data?.message,
          });
        });
    },

    updateApearence: (applyToAllHotels, hotelID = null) => {
      const hotelId = hotelID ? hotelID : state?.hotel?.key;
      updateState({ isLoading: true });
      API.updateAppearenceRequest({
        hotelId: applyToAllHotels ? null : hotelId,
        bgColor: state.bgColor,
        color1: state.color1,
        color2: state.color2,
        font: state.font,
        selectedHotelId: hotelId,
      })
        .then(_ => {
          notification.success({
            message: translate('appearence.success'),
          });
          updateState({ isLoading: false });
        })
        .catch(error => {
          updateState({ isLoading: false });
          notification.error({
            message: error?.response?.data?.message,
          });
        });
    },

    updateKiosk: (applyToAllHotels, hotelID = null) => {
      updateState({ isLoading: true });
      const hotelId = hotelID ? hotelID : state?.hotel?.key;
      API.updateAppearenceRequest({
        hotelId: applyToAllHotels ? null : hotelId,
        kioskBgColor: state.kioskBgColor,
        kioskTitleColor: state.kioskTitleColor,
        selectedHotelId: hotelId,
        isKiosk: true,
      })
        .then(_ => {
          notification.success({
            message: translate('appearence.success'),
          });
          updateState({ isLoading: false });
        })
        .catch(error => {
          notification.error({
            message: error?.response?.data?.message,
          });
          updateState({ isLoading: false });
        });
    },

    updateChain: () => {
      updateState({ isLoading: true });
      API.updateChainAppearenceRequest({
        chainId: state.chainId,
        logo: state.chainLogo,
        mainColor: state.chainColor1,
        secondaryColor: state.chainColor2,
        bgColor: state.chainBgColor,
      })
        .then(_ => {
          notification.success({
            message: translate('appearence.success'),
          });
          actions.loadAppearence(state.hotel.key);
        })
        .catch(() => {
          updateState({ isLoading: false });
          notification.error({
            message: translate('appearence.logoError'),
          });
        });
    },

    onHotelSelected: hotel => {
      updateState({ hotel: hotel });
      if (hotel?.key && hotel?.key != 'null') {
        actions.loadAppearence(hotel.key);
      }
    },

    updateValue: (answerId, value) => {
      updateState({ [answerId]: value });
    },
    formatColor: color => {
      if (!color) return undefined;
      return color.startsWith('#') ? color : `#${color}`;
    },
    changeActivePreview: (key, value) => {
      updateState({ [key]: value });
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
